/** Visible MM/YY. ePayco still receives a four-digit year (02/30 → 2030). */

export function formatCardExpiry(raw: string): string {
    const digits = raw.replace(/\D/g, '').slice(0, 4);
    if (digits.length <= 2) return digits;
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
}

export function cardExpiryParts(display: string): { month: string; year: string } | null {
    const digits = display.replace(/\D/g, '');
    if (digits.length !== 4) return null;
    const month = digits.slice(0, 2);
    const monthNum = Number(month);
    if (!Number.isInteger(monthNum) || monthNum < 1 || monthNum > 12) return null;
    return { month, year: `20${digits.slice(2)}` };
}
